// 전시 상태
export default Object.freeze({
  STATUS: '전시상태',

  Y: '전시함',
  N: '전시 안 함',
});
